import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/kebab.svg';

export const IconKebab = createIconComponent(Icon);
